// extracted by mini-css-extract-plugin
export default {"list":"DesktopNavigation_list__Yxs2e","active":"DesktopNavigation_active__J5zYI"};